import React from 'react';
import { SearchJob } from '@app/src/common/SearchJob';

export const renderPredictive = ({
  input,
  dataList,
  handleChange,
  meta: { touched, error },
  handleClickClose,
  defaultUbigeo,
  isDisabled,
  isLoading,
  activeColor,
  message,
  lastWordFound,
  handleChangeInput
}) => {

  const onChangeProp = (e) => {
    input.onChange && input.onChange(e.location);
    handleChange && handleChange(e);
  }

  return (
    <SearchJob
      dataList={dataList}
      handleChange={onChangeProp}
      handleClickClose={handleClickClose}
      activeColor={activeColor}
      handleChangeInput={handleChangeInput}
      isLoading={isLoading}
      placeholder="Ingrese un distrito"
      defaultJob={defaultUbigeo}
      message={message}
      isLoadingModal={isLoading}
      minCharForSearch={3}
      lastWordFound={lastWordFound}
      input={input}
      error={touched && error}
      disabled={isDisabled}
    />
  )
};
